export * from './confirm-dialog.module';
export * from './confirm-dialog.component';
